/**
 * Parse de ids compactos del UI: "group:option"
 */
export const parseFilterId = (id) => {
    const [g, opt] = id.split(":");
    if (!g || !opt)
        return null;
    return [g, opt];
};
/**
 * Crea un objeto de filtros vacíos
 */
export const createEmptyFilters = () => ({
    type: new Set(),
    brand: new Set(),
    size: new Set(),
    origin: new Set(),
    variety: new Set(),
});
/**
 * Aplica filtros a productos (OR dentro de cada grupo, AND entre grupos)
 */
export const filterProducts = (products, selected) => {
    const activeGroups = Object.keys(selected).filter((g) => selected[g].size > 0);
    if (activeGroups.length === 0)
        return products;
    return products.filter((p) => {
        for (const g of activeGroups) {
            const value = p[g];
            if (!selected[g].has(value))
                return false;
        }
        return true;
    });
};
